var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyePreview = function SvgEyePreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#2360A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14 19a18.683 18.683 0 0 0 2.464 3.316C13.396 24.226 15.9 26 19 26c3.1 0 5.605-1.774 7.395-3.684A18.684 18.684 0 0 0 28.86 19a18.684 18.684 0 0 0-2.464-3.316C24.605 13.774 22.101 12 19 12c-3.1 0-5.604 1.774-7.396 3.684A18.683 18.683 0 0 0 9.142 19ZM30 19l.894-.448-.002-.003-.003-.007-.011-.022a10.615 10.615 0 0 0-.192-.354 20.672 20.672 0 0 0-2.831-3.85C25.895 12.226 22.899 10 19 10c-3.9 0-6.896 2.226-8.854 4.316a20.668 20.668 0 0 0-2.832 3.85 12.38 12.38 0 0 0-.192.354l-.011.022-.003.007-.002.002s0 .002.894.449l-.894-.447a1 1 0 0 0 0 .894L8 19l-.894.447.002.004.003.007.011.022a8.467 8.467 0 0 0 .192.354 20.668 20.668 0 0 0 2.832 3.85C12.104 25.774 15.1 28 19 28c3.9 0 6.895-2.226 8.855-4.316a20.672 20.672 0 0 0 2.831-3.85 11.81 11.81 0 0 0 .192-.354l.011-.022.003-.007.002-.002s0-.002-.894-.449Zm0 0 .894.447c.141-.281.14-.613 0-.895L30 19Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#fff"
  })));
};
export default SvgEyePreview;